import { useEffect } from 'react';

const ExternalForm = () => {
  useEffect(() => {
    // Función para cargar el formulario
    const loadForm = () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          region: "na1",
          portalId: "44224986",
          formId: "f7ed3a3c-70df-4483-8fed-6050c299261f",
          target: ".hubspot-form"
        });
      }
    };

    // Verificar si el script de HubSpot ya está cargado
    if (window.hbspt) {
      // Si el script ya está cargado, cargar el formulario directamente
      loadForm();
    } else {
      // Si el script no está cargado, cargar el script y luego el formulario
      const script = document.createElement('script');
      script.src = "//js.hsforms.net/forms/embed/v2.js";
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);

      script.onload = () => {
        loadForm();
      };
    };
  }, []);

  return null;
};

export default ExternalForm;
